import getEnvValue from '../utils/getEnvValue'

class AnalyticsClient {
  APP_PREFIX = getEnvValue('REACT_APP_TRACKING_APP_PREFIX')
  APP_ENV = getEnvValue('REACT_APP_TRACKING_APP_ENV')

  async trackPageView(pageName) {
    window.appEventData = window.appEventData || [];
    window.appEventData.push({
      event: 'PageLoaded',
      page: {
        pageInfo: {
          pageName: `${this.APP_PREFIX}:${pageName}`,
          sysEnv: this.APP_ENV,
          issueDate: 'IAM|27.02.2025',
        },
        category: {
          primaryCategory: 'Web UI',
          pageType: 'Overview',
          pagePurpose: 'Information',
        },
        attributes: {
          displayedBrand: 'ERGO',
        },
      }
    });
  }

  async trackEvent(elementName) {
    window.appEventData = window.appEventData || [];
    window.appEventData.push({
      event: 'GeneralClick',
      eventdetails: {
        clickedElement: `${this.APP_PREFIX}:${elementName}`,
        clickType: 'o',
      },
      page: {
        pageInfo: {
          sysEnv: this.APP_ENV,
        },
        attributes: {
          displayedBrand: 'ERGO',
        }
      },
    });
  }
}

class AnalyticsClientMock {
  APP_PREFIX = getEnvValue('REACT_APP_TRACKING_APP_PREFIX')

  async trackPageView(pageName) {
    console.log(`[MOCK]: Tracking page view: ${this.APP_PREFIX}:${pageName}`)
  }

  async trackEvent(elementName) {
    console.log(`[MOCK]: Tracking event with name: ${elementName}`)
  }
}

let analyticsClient
const trackingEnabled = getEnvValue('REACT_APP_TRACKING_ENABLED')

if (trackingEnabled) {
  analyticsClient = new AnalyticsClient()
} else {
  analyticsClient = new AnalyticsClientMock()
}

export default analyticsClient
